import React from 'react';

import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';
import { AuditorPermissionSelect } from '@scale/shared/taskerScreening/types';

interface ISelectScreeningReviewAuditPermissionRoles {
  onChange: (roles: AuditorPermissionSelect[]) => void;
  value?: AuditorPermissionSelect[];
}

const SelectScreeningReviewAuditPermissionRoles: React.FC<
  ISelectScreeningReviewAuditPermissionRoles
> = ({ onChange, value }) => {
  const fetchScreeningReviewAuditPermissionRoles = async (search: string) => {
    try {
      const query = {
        search,
      };
      const results = await apiFetch(
        null,
        `corp-api/find/screening-review-audit-permission-roles`,
        { query },
      );
      const options = results.permissionRoles.map((permissionRole: { name: any; id: any }) => {
        return {
          label: `${permissionRole.name} (${permissionRole.id})`,
          value: permissionRole.id,
        };
      });
      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  };

  return (
    <div>
      <Select
        {...{ onChange, value }}
        loadOptions={fetchScreeningReviewAuditPermissionRoles.bind(this)}
        ignoreCase={true}
        multi
        isClearable
        defaultOptions
        placeholder="Audit Permission Roles"
      />
    </div>
  );
};

export default SelectScreeningReviewAuditPermissionRoles;
